export class Commands {
    public static readonly AdjustBalance: string = "ADJUST_BALANCE";
    public static readonly DisablePosOperations: string = "DISABLE_POS_OPERATIONS";
    public static readonly EnablePosOperations: string = "ENABLE_POS_OPERATIONS";
    public static readonly UpdateConfiguration: string = "UPDATE_CONFIGURATION";
    public static readonly RequestReport: string = "REQUEST_REPORT";
}
